<div class="flex justify-center py-4 items-center flex-wrap gap-2">

  <div class="flex justify-center items-center">
    <button mat-icon-button
            [disabled]="currentPage === 1"
            (click)="changePageNumber(1)"
            matTooltip="Jump to first">
      <mat-icon *ngIf="currentPage !== 1" svgIcon="double-chevron-left"></mat-icon>
      <mat-icon *ngIf="currentPage === 1" svgIcon="double-chevron-left2"></mat-icon>
    </button>
    <button mat-icon-button
            [disabled]="!(prevPage > 0)"
            (click)="changePageNumber(prevPage)"
            matTooltip="Previous">
      <mat-icon *ngIf="(prevPage > 0)" svgIcon="chevron-left"></mat-icon>
      <mat-icon *ngIf="!(prevPage > 0)" svgIcon="chevron-left2"></mat-icon>
    </button>
  </div>
  <div class="rounded-full cursor-pointer text-primary-500 shadow w-12 h-12 flex justify-center items-center font-medium"
       [ngClass]="page === currentPage ? 'text-white bg-primary-500/90' : 'text-primary-500 bg-white'"
       (click)="changePageNumber(page)"
       *ngFor="let page of firstPages">
    {{ page }}
  </div>

  <div
    *ngIf="!(this.pagesNumberArray?.length <= this.pageCount) && !hasOverlapped"
    class="flex justify-center w-12 h-12 items-center text-primary-500">
    ...
  </div>

  <div class="rounded-full cursor-pointer text-primary-500 shadow w-12 h-12 flex justify-center items-center font-medium"
       [ngClass]="page === currentPage ? 'text-white bg-primary-500/90' : 'text-primary-500 bg-white'"
       (click)="changePageNumber(page)"
       *ngFor="let page of lastPages">
    {{ page }}
  </div>
  <div class="flex justify-center items-center">
    <button mat-icon-button
            [disabled]="!(nextPage > 0)"
            (click)="changePageNumber(nextPage)"
            matTooltip="Next">
      <mat-icon *ngIf="(nextPage > 0)" svgIcon="chevron-right"></mat-icon>
      <mat-icon *ngIf="!(nextPage > 0)" svgIcon="chevron-right2"></mat-icon>
    </button>
    <button mat-icon-button
            [disabled]="pagesNumberArray[pagesNumberArray?.length-1] === currentPage"
            (click)="changePageNumber(pagesNumberArray[pagesNumberArray?.length-1])"
            matTooltip="Jump to last">
      <mat-icon *ngIf="pagesNumberArray[pagesNumberArray?.length-1] !== currentPage" svgIcon="double-chevron-right"></mat-icon>
      <mat-icon *ngIf="pagesNumberArray[pagesNumberArray?.length-1] === currentPage" svgIcon="double-chevron-right2"></mat-icon>
    </button>
  </div>
</div>

